<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 'AGENCY_CHECK' ? 'active' : '']" data-toggle="tab"
                           href="#agency-check-pos-requests-list" @click="gotoTab('AGENCY_CHECK')">
                                  <span>
                            <span v-text="$t('pos.tab.agency_check')"></span>&nbsp;
                            <span v-text="agency_check_pos_requests_count"
                                  class="bg-success rounded-circle px-2 text-white"></span>
                        </span>
                        </a>
                    </li>
                </ul>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 'CORRECTION' ? 'active' : '']" data-toggle="tab"
                           href="#correction-pos-requests-list" @click="gotoTab('CORRECTION')">
                                  <span>
                            <span v-text="$t('pos.tab.correction')+'('+$t('label.psp')+')'"></span>&nbsp;
                            <span v-text="correction_pos_requests_count"
                                  class="bg-success rounded-circle px-2 text-white"></span>
                        </span>
                        </a>
                    </li>
                </ul>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 'PROVIDE_INVENTORY' ? 'active' : '']"
                           data-toggle="tab"
                           href="#PROVIDE_INVENTORY-pos-requests-list" @click="gotoTab('PROVIDE_INVENTORY')">
                                  <span>
                            <span v-text="$t('pos.tab.provide_inventory')"></span>&nbsp;
                            <span v-text="provide_inventory_pos_requests_count"
                                  class="bg-success rounded-circle px-2 text-white"></span>
                        </span>
                        </a>
                    </li>
                </ul>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 'SWITCH' ? 'active' : '']" data-toggle="tab"
                           href="#SWITCH-pos-requests-list" @click="gotoTab('SWITCH')">
                                  <span>
                            <span v-text="$t('pos.tab.switch')"></span>&nbsp;
                            <span v-text="switch_pos_requests_count"
                                  class="bg-success rounded-circle px-2 text-white"></span>
                        </span>
                        </a>
                    </li>
                </ul>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 'ACTIVE' ? 'active' : '']" data-toggle="tab"
                           href="#Active-pos-requests-list" @click="gotoTab('ACTIVE')">
                                  <span>
                            <span v-text="$t('pos.tab.active')"></span>&nbsp;
                            <span v-text="active_pos_requests_count"
                                  class="bg-success rounded-circle px-2 text-white"></span>
                        </span>
                        </a>
                    </li>
                </ul>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 'DISABLE' ? 'active' : '']" data-toggle="tab"
                           href="#Disable-pos-requests-list" @click="gotoTab('DISABLE')">
                                  <span>
                            <span v-text="$t('pos.tab.disable')"></span>&nbsp;
                            <span v-text="disable_pos_requests_count"
                                  class="bg-success rounded-circle px-2 text-white"></span>
                        </span>
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 'AGENCY_CHECK' ? 'active' : '']"
                     id="agency-check-pos-requests-list">

                </div>
                <div :class="['tab-pane', currentTab === 'CORRECTION' ? 'active' : '']"
                     id="correction-pos-requests-list">

                </div>
                <div :class="['tab-pane', currentTab === 'PROVIDE_INVENTORY' ? 'active' : '']"
                     id="PROVIDE_INVENTORY-pos-requests-list">

                </div>
                <div :class="['tab-pane', currentTab === 'SWITCH' ? 'active' : '']"
                     id="SWITCH-pos-requests-list">

                </div>
                <div :class="['tab-pane', currentTab === 'ACTIVE' ? 'active' : '']"
                     id="ACTIVE-pos-requests-list">
                </div>
                <div :class="['tab-pane', currentTab === 'DISABLE' ? 'active' : '']"
                     id="DISABLE-pos-requests-list">
                </div>
            </div>
            <manage-access-filter :action="filterAction" :query="query"></manage-access-filter>
            <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import $ from "jquery";
import {posService} from '@/common/api.service'
import {KTApp} from '@/plugins/core/app'
import columns from "../../datatable/Admin_Pos_Requests_List";
import ManageAccessPosRequestsFilter from "../manage-access-pos-requests-filter";
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import ActionsPosRequests from "../actions-pos-requests";
import {posStatuses} from "@/constants/PosStatus"
import { StarShopApiUrl } from "../../../../common/api.service";


export default {
    components: {
        'manage-access-filter': ManageAccessPosRequestsFilter
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            currentTab: 'AGENCY_CHECK',
            form_data: {},
            query: {
                status:posStatuses.AGENCY_CHECK
            },
            posStatuses,
            agency_check_pos_requests_count: 0,
            correction_pos_requests_count: 0,
            provide_inventory_pos_requests_count: 0,
            switch_pos_requests_count: 0,
            active_pos_requests_count: 0,
            disable_pos_requests_count: 0,
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "pos_requests_list",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: StarShopApiUrl.path('pos/get-pos-requests'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: res => {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: ActionsPosRequests,
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
        gotoTab(selectedTab) {
            this.query = {
                status: posStatuses[selectedTab]
            }
            this.currentTab = selectedTab;
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
            window.localStorage.setItem('tr_routing_active_tab', selectedTab);
        },
        registerPos() {
            let form = $('#register_pos_form')
            let btn = $('#submit_btn')

            KTApp.progress(btn)

            posService.editPosRequest(this.form_data).then(response => {
                this.$router.push('/pos')
            })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
        }
    },
    mounted() {
        this.$store.commit('pos/canChange',true)
        posService.getPosRequestsCount().then(response => {
            this.agency_check_pos_requests_count = response.data.data.agency_check_pos_requests_count
            this.correction_pos_requests_count = response.data.data.correction_pos_requests_count
            this.provide_inventory_pos_requests_count = response.data.data.provide_inventory_pos_requests_count
            this.switch_pos_requests_count = response.data.data.switch_pos_requests_count
            this.active_pos_requests_count = response.data.data.active_pos_requests_count
            this.disable_pos_requests_count = response.data.data.disable_pos_requests_count
        })
                .catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message)
                })
    }
}
</script>

<style>

</style>